import {
  GETTER_TOKENS,
  GETTER_ACTIVE_SESSIONS,
  MUTATE_SET_ACTIVE_SESSIONS,
  ACTION_REFRESH_ACTIVE_SESSIONS, MUTATE_CLEAR_CALLS_MODULE, ACTION_CLEAR_CALLS_MODULE,
} from '@/store/types';

import {CallService} from '@/services/calls';
import {getAccessToken} from '@/utils/access-token';
import {logger} from '@/utils/logger';

const getDefaultCallsModule = () => {
  return {
    activeSessions: [],
  }
}
const state = getDefaultCallsModule();

const getters = {
  [GETTER_ACTIVE_SESSIONS]: ({activeSessions}) => activeSessions,
};

const actions = {
  [ACTION_REFRESH_ACTIVE_SESSIONS]: async ({commit, rootGetters}) => {
    let allActiveSessions = [];
    const accountToken = getAccessToken();
    let activeSessionResponse;

    try {
      activeSessionResponse = await CallService.getSessionsActive(accountToken);
    } catch (error) {
      // Preserve last-known-good activeSessions on failure; interval will retry.
      logger.error('CallService.getSessionsActive XHR failed', {}, error);
      throw error;
    }

    if (activeSessionResponse.data.length) {
      activeSessionResponse.data.forEach((item) => {
        //for doctor name and details
        const {doctor} = rootGetters[GETTER_TOKENS].find(element => element.token === item.token);
        item._doctor = doctor;
        allActiveSessions.push(item);
      })
    }
    commit(MUTATE_SET_ACTIVE_SESSIONS, allActiveSessions);
  },
  [ACTION_CLEAR_CALLS_MODULE]: ({commit}) => {
    commit(MUTATE_CLEAR_CALLS_MODULE);
  }
};

const mutations = {
  [MUTATE_SET_ACTIVE_SESSIONS]: (state, newActiveSessions) => {
    state.activeSessions = newActiveSessions;
  },
  [MUTATE_CLEAR_CALLS_MODULE]: (state) => {
    Object.assign(state, getDefaultCallsModule());
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};